
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { marked } from 'marked';
import { IAppNotification } from '@/types/notifications.types';
import { format, parseISO } from 'date-fns';
import MxModal from '@/components/global/MxModal.vue';

@Component({
    name: 'NotificationDetailModal',
    components: { MxModal }
})
export default class NotificationDetailModal extends Vue {

    @Prop({ type: Boolean, required: true })
    readonly value: boolean;

    @Prop({ type: Object as () => IAppNotification | null, default: null })
    readonly notification: IAppNotification | null;

    get parsedBody(): string {
        return marked.parse(this.notification?.body || '') as string;
    }

    formatDate(dateStr: string): string {
        try {
            return format(parseISO(dateStr), 'MMMM d, yyyy');
        } catch {
            return dateStr;
        }
    }

    async toggleRead(): Promise<void> {
        if (!this.notification) return;
        if (this.notification.isRead) {
            await this.$store.dispatch('notifications/markUnread', this.notification.id);
        } else {
            await this.$store.dispatch('notifications/markRead', this.notification.id);
        }
    }

    async deleteNotification(): Promise<void> {
        if (!this.notification) return;
        await this.$store.dispatch('notifications/deleteNotification', this.notification.id);
        this.$emit('deleted');
    }

}
